<template>
    <nav>
        <v-layout>
            <v-toolbar app color="white">
                <v-toolbar-side-icon class="hidden-md-and-up" @click="toggleDrawer" />
                <v-toolbar-title>
                  <span v-if="language==='RU'"> <a href="\" class="font-weight-bold anna-logo">Анна Братусь</a></span>&nbsp;
                  <span v-if="language==='EN'"> <a href="\" class="pinyon font-weight-bold anna-logo">Anna Bratus</a></span>&nbsp;                    
                </v-toolbar-title>

            <v-spacer></v-spacer>
                
            <span v-if="language==='RU'"><v-btn class="menu-btn hidden-sm-and-down text-capitalize" flat 
                  v-for="link in links_RU" 
                    :key="link.text" 
                      router
                        :to="link.route">
                <span class="mr-2">{{ link.text }}</span>
              </v-btn>
            </span>

            <span v-if="language==='EN'"><v-btn class="menu-btn-en hidden-sm-and-down text-capitalize" flat 
                  v-for="link in links_EN" 
                    :key="link.text" 
                      router
                        :to="link.route">
                <span class="mr-2">{{ link.text }}</span>
              </v-btn>
            </span>

              <a v-if="language==='EN'" class="flag" @click="changeLangTo('RU')"><img src="/img/russian-flag.jpg" width="40"></a>&nbsp;
              <a v-if="language === 'RU'" class="flag" @click="changeLangTo('EN')"><img src="/img/british-flag.jpg" width="40"></a>   
        </v-toolbar>
      <Drawer :drawer="drawer" />
    </v-layout>
  </nav>
</template>

<script>
  import Drawer from '@/components/Drawer'
  import * as easings from 'vuetify/es5/util/easing-patterns'
        export default {
            name: 'Header',
            components: {
            Drawer
        },
  data () {
    return {
      language: '',
      dialog: false,
      easings: Object.keys(easings),
      drawer: false,
      links_RU: [
        {text: 'Биография', route: '/about'},
        {text: 'Аудио', route: '/audio'},  
        {text: 'Фото', route: '/gallery'}, 
        {text: 'Видео', route: '/video'},
        {text: 'Награды', route: '/awards'},        
        {text: 'Контакты', route: '/contacts'}                                                 
      ],
      links_EN: [
        {text: 'Biography', route: '/about'},
        {text: 'Audio', route: '/audio'},  
        {text: 'Photo', route: '/gallery'}, 
        {text: 'Videos', route: '/video'},
        {text: 'Awards', route: '/awards'},        
        {text: 'Contacts', route: '/contacts'}                                                 
      ],
    }
  },
  mounted(){
    if(localStorage.lang){
      this.language = localStorage.lang
    } else {
      this.language = 'RU'
      localStorage.setItem('lang', 'RU')
    }
  },
  computed: {
    target () {
      const value = this[this.type]
        if (!isNaN(value)) return Number(value)
          else return value
      },
    options () {
      return {
        duration: 900,
        offset: 0,
        easing: 'easeInOutCubic'        
      }
    }
  },
  methods: {
      toggleDrawer() {
        this.drawer = !this.drawer
      },
      changeLangTo(lang) {
        localStorage.lang = lang   
        location.reload()         
      }
    }
  }
</script>

<style>
    a.anna-logo {
        font-family: 'CassandraRegular'!important;
        font-size: 30px;
        color: #222;
    }
    .menu-btn {
        font-size: 14px;
        letter-spacing: 1px;
        color: rgb(160, 158, 158)!important;
        font-family: 'CassandraRegular', sans-serif;
        font-style: normal;
        font-weight: normal;
    }
    .menu-btn-en {
        font-size: 20px;
        letter-spacing: 1px;
        color: rgb(160, 158, 158)!important;
        font-family: 'Pinyon Script';
        font-style: normal;
        font-weight: 500;      
    }
    .pinyon {
        font-family: 'Pinyon Script'!important;      
    }
    .flag {
      padding-top: 5PX;
      border: 1px dotted #777;
    }
</style>